var map = {
	"./149shots_so.jpg": 8872,
	"./214shots_so.jpg": 3580,
	"./485shots_so.jpg": 7612,
	"./524shots_so.jpg": 9640,
	"./721shots_so.jpg": 5372
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7723;